import React from 'react'
import posed, { PoseGroup } from 'react-pose'
import styled from 'styled-components'
import { navigate } from '@reach/router';

const BrandPose = posed.a({
  enter: {
    y: 0,
    opacity: 1
  },
  exit: {
    y: -20,
    opacity: 0
  }
});

const BrandWrapper = styled(BrandPose)`
  position: absolute;
  top: 20px;
  left: 20px;
  display: block;
  cursor: pointer;
  z-index: 100;
  color: white;
  text-transform: uppercase;
  @media (min-width: 1024px) {
    position: fixed;
  }
`

class BrandName extends React.Component {
  state = { isVisible: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 1500);

  }

  onClick = (e) => {
    e.preventDefault();
    navigate('/');
  }

  render() {
    const { isVisible } = this.state;

    return(
      <PoseGroup>
        {isVisible ?
          <BrandWrapper className="font-mono" key="brandName" onClick={this.onClick}>
            Soulweb Solutions
          </BrandWrapper>
          : null
        }
      </PoseGroup>
    )
  }
}

export default BrandName
